import { BFormInput } from "bootstrap-vue"
import { toString } from "bootstrap-vue/src/utils/string"

const decimalChar = "."

BFormInput.mixin({
    methods :
    {
        formatValue(value, event, force = false) {
            value = toString(value)
            
            if (this.type === "number")
            {
                value = value.replace(",", decimalChar)

                if (value.includes("e")) {
                    value = Number(value).toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 30 })
                }

            }

            if (this.hasFormatter && (!this.lazyFormatter || force)) {
              value = this.formatter(value, event)
            }
            return value
        },
    },
	mounted()
	{
		if (this.type === "number")
		{
			const element = this.$el
			const component = this
			const digits = [...Array(10)].map((_, i) => i.toString())

			element.setAttribute("type", "text")

			element.addEventListener("keypress", function (evt) {
				const prevValue = evt.target.value
				let newValue =
					prevValue.slice(0, element.selectionStart)
					+ evt.key
					+ prevValue.slice(element.selectionEnd)

				if (
					(evt.key !== "." && evt.code !== "NumpadDecimal" && evt.key !== "-" && !digits.includes(evt.key))
					|| (
                        (evt.key === "." || evt.code === "NumpadDecimal")
                        && (
                            prevValue.includes(decimalChar)
                            || (
                                component.$attrs.accuracy !== undefined
                                && component.$attrs.accuracy === 0
                            )
                        )
                    )
					
				)
				{
					evt.preventDefault()
				}

				if (evt.key === "-" && (
					element.selectionStart !== 0
					|| (component.$attrs.gt !== undefined && component.$attrs.gt >= 0)
				))
				{
					evt.preventDefault()
				}

				if (newValue.replace(".", "").replace(/^[0]+/, "").replace(/[0]+$/, "").length > 15)
				{
					evt.preventDefault()
				}
			})

			element.addEventListener("input", function (event) {
				if (isNaN(event.target.value))
				{
					element.classList.add("is-invalid")
					element.classList.remove("is-valid")
				}
				else if (component.state !== false)
				{
					element.classList.remove("is-invalid")
					if (component.state === true)
					{
						element.classList.add("is-valid")
					}
				}
			})

			element.addEventListener("paste", function (event) {
				let paste = (event.clipboardData || window.clipboardData).getData("text")
                const prevValue = event.target.value
                paste = paste.replace(",", decimalChar)
                
				let newValue =
					prevValue.slice(0, element.selectionStart)
					+ paste
					+ prevValue.slice(element.selectionEnd)

                if (isNaN(newValue))
                {
                    event.preventDefault()
                }

				if (newValue.replace(".", "").replace(/^[0]+/, "").replace(/[0]+$/, "").length > 15)
				{
					event.preventDefault()
				}
			})
		}
	}
})

export default BFormInput
